var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view"},[_c('div',{ref:"map-frame",staticClass:"map-view__frame"})])}
var staticRenderFns = []

export { render, staticRenderFns }